import React, { useContext } from "react";

import { useMaximizeScrollContainer } from "@kikoff/hooks/src/useContentHeight";
import { combineClasses } from "@kikoff/utils/src/string";

import styles from "./page_align.module.scss";

export interface PageAlignProps {
  className?: string;
  scroll?: boolean;
  wrap?: true;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  overscroll?: boolean | React.CSSProperties["height"];
  maxWidth?: React.CSSProperties["maxWidth"];
  sidePadding?: React.CSSProperties["width"];
  flexContent?: boolean;
}

export default function PageAlign(props: PageAlignProps) {
  const {
    className,
    wrap,
    scroll,
    children,
    style,
    overscroll,
    maxWidth,
    sidePadding,
    flexContent = false,
  } = { ...useContext(PageAlignContext), ...props };

  const ref = useMaximizeScrollContainer();

  return (
    <div
      ref={scroll && ref}
      className={combineClasses(
        styles["page-align"],
        wrap && styles.wrap,
        scroll && styles.scroll,
        className
      )}
      style={{ "--side-padding": sidePadding, ...style } as React.CSSProperties}
    >
      <div
        className={combineClasses(
          styles.content,
          flexContent && styles["flex"]
        )}
        style={{ maxWidth }}
      >
        <div />
        {children}
        {((overscroll !== false && scroll) || overscroll) && (
          <div
            style={{
              height:
                typeof overscroll === "string"
                  ? overscroll
                  : "calc(var(--bottom-padding) + 20px)",
            }}
          />
        )}
      </div>
    </div>
  );
}

export const PageAlignContext = React.createContext<Partial<PageAlignProps>>({
  maxWidth: "800px",
  sidePadding: "24px",
});
